import { Classes } from "../../theme/Classes"
import { useWindowSize } from "../../hooks/useWindowSize";

export const Container = ({ children }) => {

    const size = useWindowSize();
    return (
        <>
            {size?.width > 768 &&
                <div style={{ ...Classes.Container, alignItems: 'center' }}>
                    {children}
                </div>
            }
            {size?.width < 768 &&
                <div style={Classes.Container}>
                    {children}
                </div>
            }
        </>

    )
}